import { render } from "./CheckboxControlsForArray.vue?vue&type=template&id=52210e8c"
import script from "./CheckboxControlsForArray.vue?vue&type=script&lang=js"
export * from "./CheckboxControlsForArray.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__